














import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class Home extends Vue {
  updateId: number = 0;

  routes: Array<Object> = [
    { value: 'Tableau de bord', path: '/dashboard' },
    { value: 'Gestion des lignes', path: '/lines' },
    { value: 'Antennes', path: '/branches' },
    { value: 'Formulaires', path: '/forms' },
    { value: 'Extraction comptes utilisateurs', path: '/extract' },
  ];

  links: Array<Object> = [
    { label: 'Accueil', path: '#' },
    { label: 'Parents', path: '#' },
    { label: 'École', path: '#' },
    { label: 'Collectivité', path: '#' },
    { label: 'Mentions légales et conditions générales', path: '#' },
    { label: 'Politiques de confidentialité', path: '#' },
    { label: 'Contact', path: '#' },
  ];

  newRoute(): void {
    this.updateId = (this.updateId + 1) % 2;
  }
}
